import { get } from 'jquery';
import {getDevCenterDataStore} from '../../../app/store'
const initialState = {};

const examplesReducerData = state => state.examplesReducer;
const exampleKey = state => state.examplesReducer.exampleKey;
const exampleSummary = state => state.examplesReducer.exampleSummary;
const exampleParentName = state => state.examplesReducer.exampleParentName;
const exampleValue = state => state.examplesReducer.exampleValue;
const exampleResponseValue = state => state.examplesReducer.exampleResponseValue;
const allExamplesData = state => state.examplesReducer.allExamplesData;
const firstLevelKey = state => state.examplesReducer.firstLevelKey;
const secondLevelKey = state => state.examplesReducer.secondLevelKey;
const thirdLevelKey = state => state.examplesReducer.thirdLevelKey;
const jsTreeChecked = state => state.examplesReducer.jsTreeChecked;
const requestValue = state => state.examplesReducer.requestValue;
const sampleCodeValue = state => state.examplesReducer.sampleCodeValue;
const selectedSampleCode = state => state.examplesReducer.selectedSampleCode;
const exampleRestructuredData = state => state.examplesReducer.exampleRestructuredData;
const sampleCodeError = state => state.examplesReducer.sampleCodeError;
const sampleCodeUrl = state => state.examplesReducer.sampleCodeUrl;
const requestHeading = state => state.examplesReducer.requestHeading;
const downloadProgress = state => state.examplesReducer.downloadProgress;

function examplesReducer(state = initialState, action){
if(action != undefined){
    switch(action.type){
        case 'UPDATE_EXAMPLE_KEY':
            return {
                ...state,
                exampleKey: action.exampleKey
            }
        case 'UPDATE_EXAMPLE_SUMMARY':
            return {
                ...state,
                exampleSummary: action.exampleSummary
            }
        case 'UPDATE_EXAMPLE_VALUE':
            return {
                ...state,
                exampleValue: action.exampleValue
            }
        case 'UPDATE_REQUEST_VALUE':
                return {
                    ...state,
                    requestValue: action.requestValue
                }    
        case 'UPDATE_EXAMPLE_RESPONSE_VALUE':
            return {
                ...state,
                exampleResponseValue: action.exampleResponseValue
            }
        case 'UPDATE_ALL_EXAMPLES_DATA':
            return {
                ...state,
                allExamplesData: action.allExamplesData
            }
        case 'UPDATE_FIRST_LEVEL_KEY':
            return {
            ...state,
            // and update the copy with the new value
            firstLevelKey : action.firstLevelKey
            }
        case 'UPDATE_SECOND_LEVEL_KEY':
            return {
                ...state,
                // and update the copy with the new value
                secondLevelKey : action.secondLevelKey
            }
        case 'UPDATE_THIRD_LEVEL_KEY':
            return {
                    ...state,
                    // and update the copy with the new value
                thirdLevelKey : action.thirdLevelKey
            }
        case 'UPDATE_EXAMPLE_RESTRUCTURED_DATA':
            return {
                    ...state,
                exampleRestructuredData: action.exampleRestructuredData
            }
        case 'UPDATE_JS_TREE_CHECK_BOX':
                return {
                        ...state,
                        // and update the copy with the new value
                    jsTreeChecked : action.jsTreeChecked
        }
        case 'UPDATE_SAMPLE_CODE_VALUE':
                return {
                        ...state,
                        // and update the copy with the new value
                    sampleCodeValue : action.sampleCodeValue
        }
        case 'UPDATE_SELECTED_SAMPLE_CODE_VALUE':
                return {
                        ...state,
                        // and update the copy with the new value
                    selectedSampleCode : action.selectedSampleCode
        }    
        case 'UPDATE_SAMPLE_CODE_ERROR':
                return {
                    ...state,
                    sampleCodeError : action.sampleCodeError
                
        }
        case 'UPDATE_SAMPLE_CODE_URL':
                return {
                    ...state,
                    sampleCodeUrl : action.sampleCodeUrl
                
        }
        case 'UPDATE_EXAMPLE_PARENT_NAME':
            return {
                ...state,
                exampleParentName : action.exampleParentName

            } 
        case 'UPDATE_DOWNLOAD_PROGRESS':
                return {
                    ...state,
                    downloadProgress : action.downloadProgress
    
                }            
        default:
            return state;
    }
}

}

function getExamplesReducerData(){
    return examplesReducerData(getDevCenterDataStore().getState());
}

function getExampleKey(){
    return exampleKey(getDevCenterDataStore().getState());
}

function getExampleSummary(){
    return exampleSummary(getDevCenterDataStore().getState());
}

function getExampleValue(){
    return exampleValue(getDevCenterDataStore().getState());
}

function getRequestValue(){
    return requestValue(getDevCenterDataStore().getState());
}

function getExampleResponseValue(){
    return exampleResponseValue(getDevCenterDataStore().getState());
}

function getAllExamplesData(){
    return allExamplesData(getDevCenterDataStore().getState());
}

function getFirstLevelKey(){
    return firstLevelKey(getDevCenterDataStore().getState());
}

function getSecondLevelKey(){
    return secondLevelKey(getDevCenterDataStore().getState());
}

function getThirdLevelKey(){
    return thirdLevelKey(getDevCenterDataStore().getState());
}
// function to get query Parameters Current Values
function getJsTreeChecked()
{
    return jsTreeChecked(getDevCenterDataStore().getState());
}

function getSampleCodeValue()
{
    return sampleCodeValue(getDevCenterDataStore().getState());
}

function getSelectedSampleCode()
{
    if(selectedSampleCode(getDevCenterDataStore().getState()) != undefined)
    {
        return selectedSampleCode(getDevCenterDataStore().getState())["value"];
    }
    else
    {
        return selectedSampleCode(getDevCenterDataStore().getState());
    }
}

function getExampleRestructuredData()
{
    return exampleRestructuredData(getDevCenterDataStore().getState());
}

function getSampleCodeError()
{
    return sampleCodeError(getDevCenterDataStore().getState());
}

function getSampleCodeUrl(){
    return sampleCodeUrl(getDevCenterDataStore().getState());
}

function getExampleParentName(){
    return exampleParentName(getDevCenterDataStore().getState());
}

function getDownloadProgress(){
    return downloadProgress(getDevCenterDataStore().getState());
}

export default examplesReducer;
export {getExamplesReducerData, getExampleKey, getExampleSummary, getExampleValue, getExampleResponseValue, getAllExamplesData, getFirstLevelKey, getSecondLevelKey, getThirdLevelKey,getJsTreeChecked, getRequestValue, getSampleCodeValue, getSelectedSampleCode, getExampleRestructuredData, getSampleCodeError, getSampleCodeUrl, getExampleParentName,getDownloadProgress};

